export enum BoardSelectedMenuEnum {
  Task,
  Cases,
  SalesOrder,
}
